document.addEventListener('DOMContentLoaded', () => {
  googleMaps = [...document.querySelectorAll('#map')]

  if ('IntersectionObserver' in window) {
    const googleMapsObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadGoogleMapsScript()
            observer.disconnect()
          }
        })
      },
      {
        rootMargin: '150px 0px 150px 0px'
      }
    )

    googleMaps.forEach(function (lazyMap) {
      googleMapsObserver.observe(lazyMap)
    })
  } else {
    loadGoogleMapsScript()
  }
})

function loadGoogleMapsScript () {
  const mapsScript = document.createElement('script')
  mapsScript.setAttribute('type', 'text/javascript')
  mapsScript.setAttribute(
    'src',
    'https://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyBgKRDAel_PrM9wc1ntyl3SdMhTQl_8CQQ&callback=initMap'
  )

  document.body.appendChild(mapsScript)
}
